import { useMutation } from '@tanstack/react-query';
import { setAxiosAuth } from 'utils';
import { deleteResource } from 'core/api/booking/booking.api';

export const useDeleteResource = ({ accessToken = '' }) => {
  setAxiosAuth(accessToken);

  return useMutation({
    mutationFn: deleteResource,
    retry: 0,
  });
}
